import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import i18n from './i18n'
import Swal from 'sweetalert2'
import * as Sentry from '@sentry/vue'
import { VApp } from 'vuetify/lib'
import { initClarity } from './utils/clarity'

const claimsPublicEntry = /^\/(claim-transfer|claim-upload)(\/|$)/.test(location.pathname)

// Sentry — monitoring błędów panelu.
// Aktywne TYLKO gdy VUE_APP_SENTRY_DSN jest ustawione w .env (puste = wyłączone).
if (process.env.VUE_APP_SENTRY_DSN && !claimsPublicEntry) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || 'production',
    // ── NAGRYWANIE SESJI Z BŁĘDEM ──
    // Wariant zerowy (decyzja właściciela, 11.09.2026): zwykłych sesji NIE
    // nagrywamy wcale, tylko te, w których poleciał błąd. Dzięki temu nagrań
    // jest tyle, co realnych awarii — mieści się w darmowej puli, a rage clicki
    // i tak widać, bo kliknięcie w martwy przycisk zwykle kończy się błędem.
    // Podkręcenie do np. 0.1 włączy zwykłe sesje, ale wtedy trzeba sprawdzić
    // limit nagrań w planie Sentry.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration({
        // RODO: nagrywamy UKŁAD ekranu, nie treść — w panelu widać PESEL-e, numery kont i kwoty wypłat.
        // Maskowanie zostaje WŁĄCZONE. Wyłączenie któregokolwiek z tych
        // przełączników wysyła dane osobowe do Sentry i wymaga osobnej decyzji
        // oraz zmiany w polityce prywatności.
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
  })
}

// Microsoft Clarity — nagrywanie sesji i rage clicki (bezczynne bez VUE_APP_CLARITY_ID).
if (!claimsPublicEntry) initClarity()

Vue.config.productionTip = false
// <model-viewer> to web component (robot-asystent BTP) — Vue ma go nie tykać
Vue.config.ignoredElements = [/^model-viewer/]
import VueSignaturePad from "vue-signature-pad";

Vue.use(VueSignaturePad);

// Global SweetAlert2 dark theme - BTP Design System
// Override default Swal so ALL files using `import Swal from 'sweetalert2'` get dark theme
const originalFire = Swal.fire.bind(Swal);
Swal.fire = function(...args) {
  if (args.length === 1 && typeof args[0] === 'object') {
    return originalFire({
      background: '#1A2433',
      color: '#FFFFFF',
      confirmButtonColor: '#3F51B5',
      cancelButtonColor: '#546E7A',
      ...args[0],
    });
  }
  if (args.length >= 1 && typeof args[0] === 'string') {
    return originalFire({
      title: args[0],
      text: args[1] || '',
      icon: args[2] || undefined,
      background: '#1A2433',
      color: '#FFFFFF',
      confirmButtonColor: '#3F51B5',
      cancelButtonColor: '#546E7A',
    });
  }
  return originalFire(...args);
};
// PWA: rejestracja service workera → panel instalowalny z przeglądarki
// ("Zainstaluj aplikację" / Dodaj do ekranu głównego). SW jest network-first,
// więc nie serwuje starego panelu — patrz public/service-worker.js.
if (!claimsPublicEntry && 'serviceWorker' in navigator && window.location.protocol === 'https:') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.BASE_URL || '/'}service-worker.js`)
      .catch(() => {})
  })
}

new Vue({
  vuetify,
  router,
  i18n,
  render: h => claimsPublicEntry ? h(VApp, [h('router-view')]) : h(App)
}).$mount('#app')
